export var __bind = function(fn, me) {
    return function() {
        return fn.apply(me, arguments);
    };
};

export var __hasProp = Object.prototype.hasOwnProperty,
    __extends = function(child, parent) {
        // Copy "static" attributes from the parent constructor to the child constructor
        for (var key in parent) {
            if (__hasProp.call(parent, key)) {
                child[key] = parent[key];
            }
        }
        // This is the surrogate constructor, used so you don't need
        // to instantiate an instance of the parent just to setup the prototype chain
        // the statement in the surrogate constructor properly attaches
        // the constructor property to object

        function ctor() {
            this.constructor = child;
        }
        // Attach the parent's prototype to the surrogate constructor
        ctor.prototype = parent.prototype;
        // This is setting up the chain, attaching an instance of a constructor whose
        // prototype is set to the parent to the prototype property of the child
        // In naive implementations, this would be child.prototype = new parent();
        child.prototype = new ctor;
        // Allows access to the parent from user code, and used by the `super` keyword
        child.__super__ = parent.prototype;
        return child;
    },
    log_debug = function() {
        if (window.console && window.console.firebug) {
            console.log.apply(this, arguments);
        }
    },
    __slice = [].slice;
    
Array.prototype.insertAt = function(index, item) {
    return this.splice(index, 0, item);
};

String.prototype.insertAt = function(index, string) {
    if (index > 0) {
        return this.substring(0, index) + string + this.substring(index, this.length);
    } else {
        return string + this;
    }
};


Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fun /*, thisArg */) {
        'use strict';
        if (this === void 0 || this === null || typeof fun !== 'function') {
            throw new TypeError();
        }

        var
            t = Object(this),
            len = t.length >>> 0,
            thisArg = arguments.length >= 2 ? arguments[1] : void 0;

        for (var i = 0; i < len; i++) {
            if (i in t) {
                fun.call(thisArg, t[i], i, t);
            }
        }
    };
}
